var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBonus1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 39,
    viewBox: "0 0 48 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2056_1405)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.39999 21.7742C2.39999 22.5983 2.81249 23.3997 3.56249 23.8533C4.69499 24.5413 6.17249 24.1709 6.85499 23.0292L8.99999 19.4229V36.2903C8.99999 37.6285 10.0725 38.7097 11.4 38.7097C12.7275 38.7097 13.8 37.6285 13.8 36.2903V26.6129H15V36.2903C15 37.6285 16.0725 38.7097 17.4 38.7097C18.7275 38.7097 19.8 37.6285 19.8 36.2903V14.5161H24H28.8H30C31.3275 14.5161 32.4 13.435 32.4 12.0968C32.4 10.7586 31.3275 9.67742 30 9.67742H28.8H24H18.2325H13.29C10.7625 9.67742 8.42249 11.0156 7.11749 13.2006L2.74499 20.5343C2.51249 20.9199 2.39999 21.3508 2.39999 21.7742ZM10.8 3.62903C10.8 4.59151 11.1793 5.51457 11.8544 6.19515C12.5295 6.87572 13.4452 7.25806 14.4 7.25806C15.3548 7.25806 16.2704 6.87572 16.9456 6.19515C17.6207 5.51457 18 4.59151 18 3.62903C18 2.66655 17.6207 1.74349 16.9456 1.06292C16.2704 0.382343 15.3548 0 14.4 0C13.4452 0 12.5295 0.382343 11.8544 1.06292C11.1793 1.74349 10.8 2.66655 10.8 3.62903Z",
    fill: "url(#paint0_linear_2056_1405)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 9.67742V4.83871H43.2V19.3548H28.8V14.5161H24V20.5645C24 22.568 25.6125 24.1936 27.6 24.1936H44.4C46.3875 24.1936 48 22.568 48 20.5645V3.62903C48 1.6255 46.3875 0 44.4 0H27.6C25.6125 0 24 1.6255 24 3.62903V9.67742H28.8Z",
    fill: "url(#paint1_linear_2056_1405)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2056_1405",
    x1: 32.3517,
    y1: 19.3548,
    x2: 8.73474,
    y2: 7.17013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2056_1405",
    x1: 47.9614,
    y1: 12.0968,
    x2: 31.3034,
    y2: 1.09602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8251"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2056_1405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 38.7097,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBonus1);
export default __webpack_public_path__ + "static/media/icon-bonus-1.1050a0f0a6e8a2b8654c7886617222fc.svg";
export { ForwardRef as ReactComponent };